import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: Pick<SentinelTeam, 'id' | 'scheduledForDeletionAt'>;
};

export default function IdCell({
  rowData: { id, scheduledForDeletionAt },
}: Props) {
  return (
    <PlainTextCell
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      topLine={id}
    />
  );
}
